import { FC, useState } from "react";
import { useDebounce } from "use-debounce";
import MRTextField from "components/material/TextField";
import { PAGE_SIZE } from "config/pagination";
import Loader from "components/Loader";
import { Stack } from "@mui/material";
import { flattenPages } from "helpers";
import { useTranslation } from "react-i18next";
import { SelectUserProps } from "./types";
import { SelectUserWrapper } from "./styles";
import UserRow from "./UserRow";
import useInfiniteUsers from "hooks/services/users/useInfiniteUsers";
import ROLE from "types/role";

const SelectUser: FC<SelectUserProps> = ({ selectedUser, setSelectedUser }) => {
  const { t } = useTranslation();
  const [text, setText] = useState<string>("");
  const [debouncedText] = useDebounce(text, 500);

  const {
    data: pages,
    isLoading: isLoadingContacts,
    error: contactsError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteUsers({
    size: PAGE_SIZE,
    query: { roles: ROLE.SELLER, text: debouncedText },
  });

  if (contactsError) throw new Error("Cannot get users");

  const handleScroll = (e: any) => {
    if (
      e.target.clientHeight + e.target.scrollTop === e.target.scrollHeight &&
      hasNextPage
    ) {
      fetchNextPage();
    }
  };

  const avatarColors = [
    "#2DB5C7",
    "#2FE5A7",
    "#3772FF",
    "#EF452F",
    "#3A36DB",
    "#F4D35E",
  ];

  return (
    <SelectUserWrapper>
      <Stack direction="column" gap={2}>
        <MRTextField
          placeholder={t("Search by name or email..")}
          className="search-contact"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />

        <div className="contacts-dialog-box" onScroll={(e) => handleScroll(e)}>
          {isLoadingContacts ? (
            <Loader />
          ) : (
            flattenPages(pages).map((user, idx) => {
              return (
                <UserRow
                  key={user._id}
                  user={user}
                  bgColor={avatarColors[idx % 5]}
                  selectedUser={selectedUser}
                  setSelectedUser={setSelectedUser}
                />
              );
            })
          )}
          {isFetchingNextPage ? <Loader /> : <></>}
        </div>
      </Stack>
    </SelectUserWrapper>
  );
};

export default SelectUser;
